export const RESOURCE = 'usersearch';
export const ACTIONS = { Search: '/users', SearchSummary: '/userssummary' }